document.querySelectorAll('[data-collection-filter]').forEach(function (filter) {
  var searchInput = filter.querySelector('[data-collection-search]');
  var productsRoot = filter.parentElement;
  var grid = productsRoot && productsRoot.querySelector('[data-collection-grid]');
  var emptyMessage = productsRoot && productsRoot.querySelector('[data-collection-empty]');
  if (!searchInput || !grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function filterProducts() {
    var query = normalize(searchInput.value);
    var visibleCount = 0;

    cards.forEach(function (card) {
      var text = normalize(card.getAttribute('data-product-search'));
      var isVisible = !query || text.indexOf(query) !== -1;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount > 0;
    }
  }

  searchInput.addEventListener('input', filterProducts);
  filterProducts();
});
